import React, { Component } from 'react'
import {toast} from "react-toastify";
import {Link, withRouter} from "react-router-dom";

class TheGamePlay extends Component {

    constructor(props) {
        super(props);
    }

    render() {


        return (
            <div className="row rowReferral">
                <div className="col-12 gameContainerPlay">
                    <h2>Play!</h2>
                </div>
            </div>
        );
    }
}

export default withRouter(TheGamePlay);
